import {
  BarChart2 as BarChartIcon2,
  DollarSign,
  FileText as BarChartIcon,
  Globe,
  HardDrive,
  PieChart,
  Settings as SettingsIcon,
  Share2,
  Sliders,
  Users,
} from 'react-feather';
import { resourceType, roleAccessTypes, webAppRoutes } from '../../constants';
import { UserModel } from '../../models';
import { checkIsOnlyRtbCounties } from '../../pages/country-statistics/utils/checkIsOnlyRtbCounties';
import { isUserAdvertiser } from '../../utils';
import * as pages from '../lazy-components';
import { RouteItem } from '../routes.types';

const offersRouteItems: RouteItem[] = [
  {
    path: webAppRoutes.createOffer,
    resourceType: resourceType.Offer,
    roleAccessTypes: roleAccessTypes.create,
    component: pages.OfferPage,
  },
  {
    path: `${webAppRoutes.offers}/:offerId`,
    resourceType: resourceType.Offer,
    roleAccessTypes: roleAccessTypes.read,
    component: pages.OfferPage,
  },
  {
    path: webAppRoutes.offers,
    resourceType: resourceType.Offer,
    roleAccessTypes: roleAccessTypes.read,
    component: pages.Offers,
    title: 'Offers',
    icon: BarChartIcon,
    isHidden: (_, user: UserModel) =>
      isUserAdvertiser(user) && !user.hasAttachedPartners,
  },
];

const partnersRouteItems: RouteItem[] = [
  {
    path: `${webAppRoutes.partners}/:userId`,
    resourceType: resourceType.Partners,
    component: pages.PartnerUpdatePage,
  },
  {
    path: webAppRoutes.createPartner,
    resourceType: resourceType.Partners,
    roleAccessTypes: roleAccessTypes.create,
    component: pages.PartnerCreatePage,
  },
  {
    path: webAppRoutes.partners,
    resourceType: resourceType.Partners,
    roleAccessTypes: roleAccessTypes.read,
    component: pages.Partners,
    title: 'Partners',
    icon: Share2,
  },
];

const rtbRouteItems: RouteItem[] = [
  {
    path: webAppRoutes.rtb,
    resourceType: resourceType.RtbStatistic,
    roleAccessTypes: roleAccessTypes.read,
    component: pages.RtbPage,
    title: 'RTB',
    icon: PieChart,
    isHidden: (_, user: UserModel) =>
      isUserAdvertiser(user) && !user.hasAttachedRtb,
  },
  {
    path: `${webAppRoutes.rtb}/:rtbDest`,
    roleAccessTypes: roleAccessTypes.read,
    resourceType: resourceType.RtbStatistic,
    component: pages.RtbCountriesPage,
  },
];

const createCountryRouteItems = (user?: UserModel): RouteItem[] => [
  {
    path: webAppRoutes.countryStat,
    resourceType: resourceType.CountryStatistic,
    roleAccessTypes: roleAccessTypes.read,
    component: pages.CountryStatistics,
    title: checkIsOnlyRtbCounties(user) ? 'Countries RTB' : 'Countries',
    icon: Globe,
  },

  // by hosts
  {
    path: webAppRoutes.hostCountries,
    resourceType: resourceType.CountriesByHosts,
    roleAccessTypes: roleAccessTypes.read,
    component: pages.HostByCountries,
    title: 'Countries',
    icon: Globe,
  },
];

export const createRouteItems = (user?: UserModel): RouteItem[] => [
  ...offersRouteItems,
  ...partnersRouteItems,
  ...rtbRouteItems,

  {
    path: webAppRoutes.hosts,
    resourceType: resourceType.Hosts,
    roleAccessTypes: roleAccessTypes.read,
    component: pages.Hosts,
    title: 'Hosts',
    icon: HardDrive,
  },

  {
    path: webAppRoutes.settings,
    resourceType: resourceType.Settings,
    roleAccessTypes: roleAccessTypes.read,
    component: pages.Settings,
    title: 'Settings',
    icon: SettingsIcon,
  },

  {
    path: webAppRoutes.userStat,
    resourceType: resourceType.Users,
    roleAccessTypes: roleAccessTypes.read,
    component: pages.UsersStatistic,
    title: 'Managers',
    icon: Users,
  },

  {
    path: webAppRoutes.ltv,
    resourceType: resourceType.Ltv,
    roleAccessTypes: roleAccessTypes.read,
    component: pages.LtvPage,
    title: 'LTV',
    icon: DollarSign,
  },

  ...createCountryRouteItems(user),

  {
    path: webAppRoutes.trends,
    resourceType: resourceType.Trends,
    component: pages.Trends,
    title: 'Trends',
    icon: BarChartIcon2,
  },

  {
    path: webAppRoutes.adminPanel,
    resourceType: resourceType.Admin,
    component: pages.AdminPanel,
    title: 'Admin Panel',
    icon: Sliders,
  },

  {
    path: webAppRoutes.createUser,
    roleAccessTypes: roleAccessTypes.read,
    resourceType: resourceType.CreateUser,
    component: pages.UserCreatePage,
  },

  {
    path: `${webAppRoutes.userPage}/:userId`,
    roleAccessTypes: roleAccessTypes.read,
    resourceType: resourceType.CreateUser,
    component: pages.UserUpdatePage,
  },

  {
    path: webAppRoutes.hostByCountries,
    roleAccessTypes: roleAccessTypes.read,
    resourceType: resourceType.Hosts,
    component: pages.HostByCountries,
  },
];
